import { BannerMain } from "@gromia/components/blog/Banner";
import { Breadcrumbs } from "@gromia/components/blog/Breadcrumbs";
import { Layout } from "@gromia/components/ui/Layout";
import { Text } from "@gromia/components/ui/Text";
import strings from "@gromia/strings/blogGuides";
import { WpCatTagT, WpListStats } from "@gromia/utils/models/blog";
import { useString } from "@gromia/utils/useString";
import { Link } from "gatsby";
import * as React from "react";

import * as s from "@gromia/components/theme/t.module.css";
import { Seo } from "@gromia/Seo";
import cx from "classnames";
import * as O from "fp-ts/lib/Option";

export type GuideData = {
  basename: string;
  pagePath: string;
  pdfPath: string;
  jpgPath: string;
  pdfMtime: string;
  title: string;
  description: string;
  pages: string;
  tags: string[];
};

type Props = {
  pageContext: {
    list: Array<GuideData>;
    categoriesAndTags: (WpCatTagT & WpListStats)[];
  };
};

function Page(props: Props) {
  const { tx, raw } = useString("blogGuides", strings);
  const list = props.pageContext.list;
  return (
    <Layout headerAlwaysLight>
      <Seo title={raw("seoTitle")} description={raw("seoDescription")} />
      <div className={cx(s.bgLight2, s.space1)}>
        <div className={cx(s.container)}>
          <Breadcrumbs
            raw={O.some({ to: "/blog/guide", label: "Guide" })}
            category={O.none}
            post={O.none}
          />
          <div className={cx(s.textCenter, s.maxWidth680, s.mAuto)}>
            <Text tag="p" s="pill">
              {tx("listTitle1")}
            </Text>
            <Text tag="h1" s="title">
              {tx("listTitle2")}
            </Text>
          </div>
          <div className={cx(s.spaceTop1, s.p0, s.listUnstyled, s.textCenter)}>
            {list.map(guide => (
              <span
                key={guide.pdfPath}
                className={cx(s.p2, s.dInlineBlock)}
                style={{ maxWidth: 278 }}
              >
                <GuideCard guide={guide} />
              </span>
            ))}
          </div>
        </div>
        <div
          className={cx(s.spaceTop2, s.textCenter, s.container, s.maxWidth680)}
        >
          <Text tag="h2" s="titleSmall">
            {tx("experts")}
          </Text>
          <BannerMain target={O.none} />
        </div>
      </div>
    </Layout>
  );
}

export function GuideCard(props: { guide: GuideData }) {
  return (
    <Link
      to={props.guide.pagePath}
      className={cx(s.textDecorationNone, s.textBody)}
    >
      <div
        key={props.guide.basename}
        className={cx(s.positionRelative, s.mxAuto)}
        style={{ minWidth: 254, maxWidth: 280 }}
      >
        <div
          style={{
            backgroundImage:
              `url('${props.guide.jpgPath}'), url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mO8+fDVfwAI5AOlaQgBWgAAAABJRU5ErkJggg==')`,
          }}
          className={cx(s.rounded, s.minHeight380, s.w100, s.bgCover)}
        />
      </div>
    </Link>
  );
}

export default Page;
